import DialogBox from './DialogBox';

export { DialogBox };
export default DialogBox;
